import {
  CircularProgress,
  FileDownloadOutlinedIcon,
  IconButton,
  useTheme,
} from '@cmg/design-system';
import type { FC } from 'react';

export type ExportButtonProps = Readonly<{
  loading: boolean;
  onExport: () => void;
}>;

export const ExportButton: FC<ExportButtonProps> = ({ loading, onExport }) => {
  const theme = useTheme();

  return (
    <IconButton size="small" onClick={onExport} aria-label="Export" disabled={loading}>
      {loading && (
        <CircularProgress
          variant="indeterminate"
          size={theme.spacing(4)}
          sx={{ position: 'absolute' }}
        />
      )}
      <FileDownloadOutlinedIcon color="primary" />
    </IconButton>
  );
};
